import React, { useState } from 'react'
// import PropTypes from 'prop-types'
import MomentUtils from '@date-io/moment';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import {
  DatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import moment from "moment";
import styled from 'styled-components';
import { createMuiTheme, makeStyles, InputAdornment, Icon } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import "moment/locale/es";

// const Label = styled.label`
//   font-size: 13px;
//   line-height: 18px;
//   letter-spacing: 0.05em;
//   color: #ff6868;
//   display: block;
//   margin-bottom: .68em;
// `
const defaultMaterialTheme = createMuiTheme({
  palette: {
    primary: { 500: '#5E388A' },
  },
});

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    // border: '1px solid #CCCCCC',
    background: props => props.value ? '#ffff' : 'transparent',
    borderRadius: '12px',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#CCCCCC',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#5E388A',
      borderWidth: '1px'
    },
    '& input': {
      padding: props => props.value ? '15px 8px 15px 8px' : '14px 0px 14px 16px',
      color: '#5E388A !important',
      fontWeight: props => props.value ? 500 : 'normal',
      fontFamily: '"Open Sans"',
      fontSize: props => props.value ? '14px' : '16px',
      // color: '#6A6A6A !important',
      width: props => props.inputWidth,
      '&::placeholder': {
        textOverflow: 'ellipsis !important',
        color: '#6A6A6A !important',
        opacity: 1
      }
    },
  }
}));
const CrossContainer = styled.div`
  display: flex;
  justify-content: center;
  cursor: pointer;
`

const InputDate = ({ value = null, handleChange, label, ...rest }) => {
  // const inputWidth = value ? `${(moment(value).format('DD MMM YYYY').length+1)*8}px` : `${(label.length+1)*8}px`
  const inputWidth = value ? `${moment(value).format('DD MMM YYYY').length}ch` : `${label.length}ch`
  // console.log('VALUE INPUTDATE', moment(value).format('DD MMM YYYY'));
  // console.log('INPUT WIDTH', inputWidth);
  const classes = useStyles({inputWidth, value: value ? true : false});
  const [dropdown, setDropdown] = useState(false)
  return (
    <ThemeProvider theme={defaultMaterialTheme}>
      <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale='es'>
        <DatePicker
          autoOk
          placeholder={label}
          value={value}
          onChange={handleChange}
          onOpen={() => setDropdown(true)}
          onClose={() => setDropdown(false)}
          format="DD MMM YYYY"
          inputVariant="outlined"
          variant='inline'
          clearable={true}
          InputProps={{
            classes:{
              ...classes,
              input: classes.input
            },
            endAdornment: (
              <InputAdornment position={'end'} style={{ marginLeft: 'auto' }}>
                <Icon>
                  {
                    dropdown
                    ? <ArrowDropUpIcon style={{ color: '#5e388a' }} />
                    : <ArrowDropDownIcon style={{ color: '#5e388a' }} />
                  }
                  <ArrowDropDownIcon style={{ color: '#5e388a' }} />
                </Icon>
              </InputAdornment>
            ),
            startAdornment: value ?  (
              <CrossContainer onClick={(e) => {e.stopPropagation(); handleChange(null)}}>
                <img src={require('../../../../assets/icons/cross_purple.svg')} alt='cross'/>
              </CrossContainer>
            ) : null
          }}
          // rightArrowIcon={() => ArrowDropDownIcon}
          style={{ width: '100%' }}
          {...rest}
        />
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  )
}

InputDate.propTypes = {

}

export default InputDate
